import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { ListChecks, LogIn, UserCircle2 } from "lucide-react";
import { usePortalAuth } from "@/context/PortalAuthContext";
import plannerApi from "@/lib/plannerApi";

const HDB_LOGO = "https://customer-assets-jai6qajn.emergentagent.net/job_pdf-guide-dev/artifacts/7s3f15d0_HDB%20LOGO.webp";
let claimed = false;

export const PlannerShell = ({ children, wide = false }) => {
    const { client } = usePortalAuth();
    const loc = useLocation();
    useEffect(() => {
        if (client && !claimed) {
            claimed = true;
            plannerApi.post("/claim").catch(() => {});
        }
    }, [client]);
    const next = encodeURIComponent(loc.pathname + loc.search);
    return (
        <div className="min-h-screen bg-[#f6f8f4]" data-testid="planner-shell">
            <header className="sticky top-0 z-30 bg-white/90 backdrop-blur border-b border-slate-200 print:hidden">
                <div className={`${wide ? "max-w-7xl" : "max-w-5xl"} mx-auto px-4 py-3 flex items-center gap-3`}>
                    <Link to="/portal/essentials-planner" className="flex items-center gap-2" data-testid="planner-home-link">
                        <img src={HDB_LOGO} alt="Har Din Bachat" className="w-9 h-9 object-contain rounded-lg bg-white"/>
                        <div className="leading-tight">
                            <div className="font-black text-slate-900 text-sm" style={{ fontFamily: "'Chivo',sans-serif" }}>Plan Your Essentials</div>
                            <div className="text-[10px] uppercase tracking-widest text-emerald-700 font-bold">Har Din Bachat</div>
                        </div>
                    </Link>
                    <div className="ml-auto flex items-center gap-2">
                        <Link to="/portal/essentials-planner/lists" data-testid="planner-my-lists-link"
                              className="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-bold text-slate-700 hover:bg-slate-100">
                            <ListChecks size={15}/> <span className="hidden sm:inline">My lists</span>
                        </Link>
                        {client ? (
                            <Link to="/portal/dashboard" data-testid="planner-account-link"
                                  className="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-bold text-slate-700 hover:bg-slate-100">
                                <UserCircle2 size={15}/> <span className="hidden sm:inline max-w-[140px] truncate">{client.name}</span>
                            </Link>
                        ) : (
                            <Link to={`/portal/signin?next=${next}`} data-testid="planner-signin-link"
                                  className="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-bold bg-slate-900 text-white hover:bg-slate-800">
                                <LogIn size={15}/> Sign in
                            </Link>
                        )}
                    </div>
                </div>
            </header>
            <main className={`${wide ? "max-w-7xl" : "max-w-5xl"} mx-auto px-4 py-6 md:py-10`}>{children}</main>
        </div>
    );
};
